import { useMutation } from 'react-query';

import { grantCertificateConsent } from '../../services/api';
import { queryClient, queryKeys } from '../../utils/react-query';

export const useGrantCertificateConsent = (registrationId: string) => {
  const { mutate, mutateAsync, isLoading } = useMutation(grantCertificateConsent, {
    onSuccess: () => queryClient.invalidateQueries([queryKeys.energyAnalysis, registrationId])
  });

  return { grantCertificateConsent: mutate, grantCertificateConsentAsync: mutateAsync, isLoading };
};
